export const addHrefTag = (rawstring) => {
  if(rawstring.indexOf('</a>') >= 0) return rawstring
  const regexp_url = /((h?)(ttps?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g;
  const ret_str = rawstring.replace(regexp_url, (all, url, h, href) => `<a href="h${href}">${url}</a>`)
  return ret_str
}


export const colorlizeUserName = (rawstring) => {
  if(rawstring.indexOf('">@') >= 0) return rawstring
  const userExp = /@[a-zA-Z0-9_]+/g
  const ret_str = rawstring.replace(userExp, (username) => `<p class="has-text-link">${username}</p>`)
  return ret_str
}


export const colorlizeHashTag = (rawstring) => {
  if(rawstring.indexOf('">#') >= 0) return rawstring
  const userExp = /#[\S]+/g
  const ret_str = rawstring.replace(userExp, (username) => `<p class="has-text-link">${username}</p>`)
  return ret_str
}


export const addHtmlTags = (rawstring) => {
  rawstring = addHrefTag(rawstring)
  rawstring = colorlizeUserName(rawstring)
  rawstring = colorlizeHashTag(rawstring)
  rawstring = rawstring.replace(/\\n/g, '\n')
  return rawstring.replace(/\n/g, '<br>')
}


export const extractURL = (str) => {
	var pat = /((h?)(ttps?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g
	var urlList = str.match(pat)
	if(!urlList) return []
	return [...new Set(urlList)]  // 重複を削除
}
